import useTypedContext from "hooks/useTypedContext";

import { ModuleSettingsContext } from "../Context";
import ModuleSettingsSharingEditForm from "./EditForm";
import ModuleSettingsSharingViewForm from "./ViewForm";

const ModuleSettingsAvailability = () => {
  const { canManageModule } = useTypedContext(ModuleSettingsContext);

  return (
    <>
      {canManageModule.result ? (
        <ModuleSettingsSharingEditForm />
      ) : (
        <ModuleSettingsSharingViewForm />
      )}
    </>
  );
};

export default ModuleSettingsAvailability;
